import { useSettings } from '../Contexts/SettingsContext';
export function useTransactionType() {
    var _a = useSettings(), smartContractData = _a.smartContractData, orderToken = _a.orderToken;
    return orderToken || smartContractData ? 'single' : 'multi';
}
